import React, {Component} from 'react';
import {annotationStatus, startSaveNote} from '../actions';
import { connect } from 'react-redux';

class NoteTool extends Component {
	constructor(props) {
		super(props);
		this.state = {
			titleValue: '',
			textValue: ''
		}
	}
	saveNote() {
		let note = {
			text: this.state.textValue,
			title: this.state.titleValue,
			url: window.location.href,
			author: this.props.author,
			context: {
				left: this.props.mousePosition.left,
				top: this.props.mousePosition.top,
				user_agent: window.navigator.userAgent,
				viewport_width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
				viewport_height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
			}
		};
		this.props.startSaveNote(note);
	}
	updateTitleValue(e) {
		this.setState({
			titleValue: e.target.value
		});
	}
	updateTextValue(e) {
		this.setState({
			textValue: e.target.value
		});
	}
	render() {
		/*
		 noteTool: {
		 show: function(e) {
		 if ($(e.target).closest('.webnotes_bar, .webnotes_notetool, .webnotes_note').length === 0) {
		 $(document).off('click', app.noteTool.show);
		 $('.webnotes_notetool [data-property]').val('');
		 $('.webnotes_notetool').css({ left: e.pageX, top: e.pageY }).addClass('webnotes_notetool-show');
		 app.$currentElement = $(e.target);
		 }
		 },
		 close: function() {
		 $(document).on('click', app.noteTool.show);
		 $('.webnotes_notetool').removeClass('webnotes_notetool-show');
		 }

		 }
		 */
		let noteToolClass = this.props.isSaving ? 'webnotes_notetool webnotes_waiting' : 'webnotes_notetool';
		return (
			<div className={noteToolClass} style={this.props.mousePosition}>
				<button className="webnotes_notetool-close" onClick={this.props.disableAnnotation}>X</button>
				<input type="text" placeholder={this.props.noteTitle} data-property="title" onChange={e => this.updateTitleValue.bind(this)(e)}/><br /><textarea placeholder={this.props.noteText} data-property="text" onChange={e => this.updateTextValue.bind(this)(e)} /><button className="webnotes_notetool-savenote" onClick={this.saveNote.bind(this)}>{this.props.saveNote}</button>
				<div className="webnotes_notetool-error" />
			</div>
		)
	}
}

const mapStateToProps = state => ({
	annotationStatus: state.annotationStatus,
	mousePosition: state.mousePosition,
	author: state.author,
	isSaving: state.isSaving
});
const mapDispatchToProps = dispatch => {
	return {
		disableAnnotation: () => {
			dispatch(annotationStatus('inactive'))
		},
		startSaveNote: note => {
			dispatch(startSaveNote(note))
		}
	}
}
export default connect(mapStateToProps, mapDispatchToProps)(NoteTool);


// WEBPACK FOOTER //
// ./src/js/components/NoteTool.js